import { authFetch, BASE_BACKEND_URL } from '../auth'
import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import ClientApplicationDetails from './ClientApplicationDetails'
import LoadingScreen from '../components/LoadingScreen'

const ClientApplicationApp = () => {
  const navigate = useNavigate()

  const [isFetching, setIsFetching] = useState(true)
  const [data, setData] = useState([])
  const [showSuccessMessage, setShowSuccessMessage] = useState(false)

  // AbortController
  const abortControllerRef = useRef(new AbortController())

  useEffect(() => {
    const controller = abortControllerRef.current
    const handleBeforeUnload = () => controller.abort('Fetch aborted by user.')

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
      controller.abort()
    }
  }, [])

  const setQueryParams = useCallback(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const success = urlParams.get('success')
    if (success) setShowSuccessMessage(true)
  }, [])

  const hideSuccessAlert = useCallback(() => {
    setShowSuccessMessage(false)
  }, [])

  const fetchDataFromServer = useCallback(async () => {
    setIsFetching(true)
    try {
      const response = await authFetch(
        `${BASE_BACKEND_URL}/clients_applications`,
        {
          method: 'GET',
          signal: abortControllerRef.current.signal,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      )

      if (!response.ok) {
        console.error(`Error en ClientApplicationApp.js: ${response.status}`)
        return
      }

      const data = await response.json()

      if (!Array.isArray(data) || data.length === 0) {
        navigate('/crear_solicitud_cliente_nuevo')
        return
      }

      setData(data)
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error:', error)
      }
    } finally {
      setIsFetching(false)
    }
  }, [navigate])

  useEffect(() => {
    setQueryParams()
    fetchDataFromServer()
  }, [fetchDataFromServer, setQueryParams])

  if (isFetching || !data || data.length === 0) {
    return <LoadingScreen text="Cargando..." />
  }

  return (
    <>
      {showSuccessMessage && (
        <div className="alert alert-success" role="alert">
          <button
            type="button"
            className="btn-close"
            onClick={hideSuccessAlert}
            aria-label="Close"
          ></button>
          <strong className="success-message">
            La solicitud de cliente nuevo fue creada exitosamente
          </strong>
        </div>
      )}

      <div className="main-show-header">
        <h2>Solicitud de cliente nuevo</h2>
      </div>

      <div className="index-table">
        <div className="show-area">
          <ClientApplicationDetails data={data} />
        </div>
      </div>
    </>
  )
}

export default ClientApplicationApp
